'use es6';

import PortalIdParser from 'PortalIdParser';
import { getFullUrl } from 'hubspot-url-utils';
import { na1 } from 'hubspot-url-utils/hublets';
import userInfo from 'hub-http/userInfo';
import noAuthApiClient from 'hub-http/clients/noAuthApiClient';
import Raven from 'Raven';
import * as ActionTypes from './ActionTypes';
import { getHub } from '../clients/hubsClient';
export const getAuth = () => dispatch => {
  PortalIdParser.get();
  return userInfo().then(({
    user,
    gates,
    portal
  }) => {
    Raven.setUserContext({
      id: user.user_id,
      email: user.email,
      locale: user.locale
    });
    dispatch({
      type: ActionTypes.INITIALIZE_AUTH,
      user,
      gates,
      portal
    });
  });
};
export const getHubScopes = () => dispatch => {
  dispatch({
    type: ActionTypes.HUB_FETCH_REQUESTED
  });
  return getHub().then(({
    scopeLimitInfo: {
      scopes
    }
  }) => {
    dispatch({
      type: ActionTypes.HUB_FETCH_RECEIVED,
      payload: scopes
    });
  }).catch(err => {
    dispatch({
      type: ActionTypes.HUB_FETCH_FAILED,
      payload: err
    });
  });
}; // TODO move to early requester?

export const checkUserLoggedIn = () => dispatch => {
  dispatch({
    type: ActionTypes.LOGIN_VERIFY_CHECKED
  });
  return noAuthApiClient.get('/login-verify/echo/user', {
    timeout: 2000
  }).then(resp => {
    const {
      pathname,
      search
    } = window.location;

    if (resp.email.includes('@hubspot.com') && !search.includes('_redirect=true')) {
      // Turn off public redirect for internal hubspotters. Useful for
      // sales and customer success teams who don't always want the in-app version
      return;
    }

    const redirectUrl = `${getFullUrl('app', {
      hubletOverride: na1
    })}/l/ecosystem${pathname.replace(/^\/(de|es|fr|ja|pt|nl|it)/, '')}${search}`;
    window.location.replace(redirectUrl);
  }).catch(() => {// Public, not logged-in user, we don't have to do anything
  });
};